export const dialog = {
  colorScheme: {
    dark: {
      background: '{surface.500}',
      header: {
        padding: '40px 40px 24px 40px',
      },
      content: {
        padding: '0 40px 48px 40px',
      },
      footer: {
        padding: '0 40px 40px 40px',
      },
    },
  },
};
